<template>
<div class="clum2left right">
  <div id="account_block">
    <div id="account_title">حساب کاربری شما</div>
    <div class="myaccountlist">
      <ul class="myaccountlist">
        <li v-bind:class="{ current: isProfileActive }" @click="clickProfile()">
          <div class="myaccounticon right"><img src="../../../assets/images/acc_icon_01.png" width="38" height="38" alt="" /></div>
          <a href="javascript:void(0)">پروفایل</a>
        </li>
        <li v-bind:class="{ current: isMapsActive }" @click="clickMaps()">
          <div class="myaccounticon right"><img src="../../../assets/images/acc_icon_02.png" width="38" height="38" alt="" /></div>
          <a href="javascript:void(0)">نقشه ها و بروزرسانی ها</a>
        </li>
        <li>
          <div class="myaccounticon right"><img src="../../../assets/images/acc_icon_03.png" width="38" height="38" alt="" /></div>
          <a href="javascript:void(0)" @click="clicklogout()">خروج</a>
        </li>
      </ul>
    </div>
  </div>
  <div id="update_block">
    <div id="update_content">
      <div class="update_title">Map Updater 3</div>
      <div class="update_img"></div>
      <div>
        <form method="get" action="http://maptool.polnav.com.tw/fixture/Flash/MapUpdater3/mapupdater3_setup.exe">
          <button class="button-warning pure-button login_input">دانلود</button>
        </form>
      </div>      
    </div>
  </div>
</div>
<!-- Left Content -->
</template>
<script>
/*jshint esversion: 6 */
import router from '../../../router.js';
export default {
  data: function() {
    return {
      isProfileActive: false,
      isMapsActive: true
    };
  },
  methods: {
    clickProfile: function() {
      this.isProfileActive = true;
      this.isMapsActive = false;
      router.replace('/Main/Profile');
    },
    clickMaps: function() {
      this.isProfileActive = false;
      this.isMapsActive = true;
      router.replace('/Main/Maps');
    },
    clicklogout: function() {
      sessionStorage.removeItem('accountid');
      sessionStorage.removeItem('email');
      sessionStorage.removeItem('first_name');
      sessionStorage.removeItem('psw');
      router.replace('/');
    }
  },
  mounted() {
    if (this.$route.path.substr(0, 11) === '/Main/Index') {
      this.isProfileActive = false;
      this.isMapsActive = false;
    }else if (this.$route.path.substr(0, 13) === '/Main/Profile') {
      this.isProfileActive = true;
      this.isMapsActive = false;
    } else if (this.$route.path.substr(0, 10) === '/Main/Maps') {
      this.isProfileActive = false;
      this.isMapsActive = true;
    }
  },
  watch: {
    $route() {
      if (this.$route.path.substr(0, 11) === '/Main/Index') {
        this.isProfileActive = false;
        this.isMapsActive = false;
      } else if (this.$route.path.substr(0, 13) === '/Main/Profile') {
        this.isProfileActive = true;
        this.isMapsActive = false;
      } else if (this.$route.path.substr(0, 10) === '/Main/Maps') {
        this.isProfileActive = false;
        this.isMapsActive = true;
      }
    }
  }
};
</script>
<style scoped>
.button-download {
  width: 196px;
  background: rgb(255, 90, 0);
  /* this is a green */
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// Aside.vue?937591ee